<template>
  <div class="orgnotice_">
    <el-row class="el-row_h" style="margin-bottom:0;">
      <el-col :span="24">
          <div class="grid-content bg-purple-dark layout_box flex s_bg" style="overflow: auto;">
       <el-select v-model="AuditStateValue" placeholder="请选择" size="small" class="s_padding">
                  <el-option v-for="item in AuditStateList" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
          	    <el-input  placeholder="请输入标题/内容/备注..." style="width:300px;" size="small" v-model="keyword"></el-input>
                <button class="btn btn-default btn-sm btc" type="submit" @click="getNoticeList()">
                  查询
                </button>
      </div>
          <div style="height: calc(100% - 50px);">
            <el-table :data="list" style="width: 100%;" height="calc(100% - 140px)">
              <el-table-column prop="Title" label="标题" width="180"></el-table-column>
              <el-table-column prop="Content" label="内容"> </el-table-column>
              <el-table-column prop="ReadTime" label="读取时间">
                <template slot-scope="scope">
                  <div>
                        {{scope.row.ReadTime=="0001-01-01 00:00:00"?'— —':scope.row.ReadTime}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="Remark" label="备注"> </el-table-column>
            </el-table>
            </div>
            <div class="pagination_mb text-center">
        <pageination :pagerPro="pager" @ee="pageFn"></pageination>
      </div>
    </el-col>
     </el-row>
  </div>

</template>

<script>
import pageination from "../paging.vue";

export default {
  name: "insstationmessage",
  components: {
    pageination
  },
  data() {
    return {
      loading: "",
      ishow: "",
      selectType: true,
      loadingsave: "",
      title: "",
      content: "",
      Remark: "",
      isShowReject: false,
      AuditState: 2,
      Id: -1,
      pager: {},
      recordCount: 0,
      loading: false,
      AuditStateList:[
        {
          value: -1,
          label: '全部'
        }, {
          value: 0,
          label: '未读'
        }, {
          value: 1,
          label: '已读'
        }
      ],
      AuditStateValue:-1,
      rejectvalue:"",
	  querydatas:"",
	  list:[],
	  keyword:''
    };
  },
  created() {
    this.pager.PageNo = 1;
    this.pager.PageSize = 20;
    this.getNoticeList();
  },
  methods: {
  
    //获取通知列表
    getNoticeList() {
      this.loading = true;
      var url = "/SiteLetter/QryAgentSiteLetterPageList";
      let postData = {
		  Keyword:this.keyword,
		  IsRead:this.AuditStateValue
	  }
      this.$loginapi.postWithPage(
        url,
        this.pager.PageNo,
        this.pager.PageSize,
        postData,
        response => {
          this.loading = false;
          if (response.Ret == 0) {
            //请求成功，response为成功信息参数
        
            this.list = response.Data;
            this.pager = response.Pager;
            if (this.pager.PageNo == 1) {
              this.recordCount = this.pager.RecordCount;
            } else {
              this.pager.RecordCount = this.recordCount;
            }
          } else {
            this.$alert(response.Msg, {});
          }
        }
      );
    },
    //    分页
    pageFn(size, pageno) {
      this.pager.PageSize = size;
      this.pager.PageNo = pageno;
      this.getNoticeList();
    }
  }
};
</script>

<style scoped>
.rejectvalue{
    width: 98%;
    height: 26px;
    padding-left: 10px;
    border: 1px solid #ccc;
}
</style>



// WEBPACK FOOTER //
// src/components/selects/insstationmessage.vue